export default __webpack_public_path__ + "static/1-splash-7645e2512af2856f62826fee6615a6b9.jpg";